export function logoShowcase() {
    const showcases = document.querySelectorAll('[data-logo-showcase]');

    if (!showcases.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const verticalLayout = window.matchMedia('(min-width: 48rem)');

    const cleanups = [];
    showcases.forEach((showcase) => {
        const columns = showcase.querySelectorAll('[data-logo-showcase-column]');

        columns.forEach((column) => {
            const track = column.querySelector('[data-logo-showcase-track]');
            const source = track?.querySelector('[data-logo-showcase-group]');

            if (!track || !source || !source.children.length || reduceMotion.matches) return;

            const appendClone = () => {
                const clone = source.cloneNode(true);
                clone.setAttribute('aria-hidden', 'true');
                track.appendChild(clone);
            };

            const smallestSourceSize = Math.min(source.offsetWidth, source.offsetHeight);
            const largestViewportSize = Math.max(window.innerWidth, column.parentElement?.clientHeight || 0);
            const cloneCount = smallestSourceSize
                ? Math.min(Math.ceil(largestViewportSize / smallestSourceSize) + 1, 20)
                : 1;

            for (let index = 0; index < cloneCount; index += 1) {
                appendClone();
            }

            let offset = 0;
            let previousTime = performance.now();
            let frameId = 0;
            const speed = 112;
            const direction = column.dataset.direction === 'down' ? 1 : -1;

            const animate = (time) => {
                const isVertical = verticalLayout.matches;
                const gap = parseFloat(getComputedStyle(track).gap || 0);
                const groupSize = (isVertical ? source.offsetHeight : source.offsetWidth) + gap;
                const elapsed = Math.min(time - previousTime, 50) / 1000;
                previousTime = time;

                if (groupSize) {
                    offset += speed * elapsed;
                    offset %= groupSize;
                    const translate = direction < 0 ? -offset : offset - groupSize;
                    track.style.transform = isVertical
                        ? `translate3d(0, ${translate}px, 0)`
                        : `translate3d(${translate}px, 0, 0)`;
                }

                frameId = requestAnimationFrame(animate);
            };

            frameId = requestAnimationFrame(animate);

            cleanups.push(() => cancelAnimationFrame(frameId));
        });
    });
    return () => cleanups.forEach((cleanup) => cleanup());
}
